import { ReactElement } from 'react';

import {
  Typography,
  Icon,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';

import styles from './styles.module.scss';

export function ErrorElementOnInjected({
  rebuild,
}: {
  rebuild: () => void;
}): ReactElement {
  return (
    <div className={styles.error}>
      <button className={styles.button} onClick={rebuild}>
        <Typography variant='body3' className={styles.text}>
          Виджет не загрузился
        </Typography>
        <Icon size='medium' iconName={Icons.Refresh} className={styles.icon} />
      </button>
    </div>
  );
}
